import {
  GET_USERS_TERMINALS_FAILD,
  GET_USERS_TERMINALS_LOADING,
  GET_USERS_TERMINALS_SUCCESS,
} from "../types";

const initialState = {
  terminals: null,
  loading: null,
  error: null,
};

export const getUsersTerminalsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_USERS_TERMINALS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_USERS_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        terminals: action.payload,
      };
    case GET_USERS_TERMINALS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
